import "./News2.module.css";
import Header from "@/reusable_sections/Header";
import WartaBeritaHero from "./sections/WartaBeritaHero";
import ZonaPPNewsGrid from "./sections/ZonaPPNewsGrid";
import Feature from "./sections/Feature";
import Footer from "@/reusable_sections/Footer";
export default function News2Page() {
  return <div>
      <Header />
      <WartaBeritaHero />
      <ZonaPPNewsGrid />
      <Feature />
      <Footer />
    </div>;
}